import _ from 'lodash'
import getUrl from "./getUrl";

let itemType = []

export function loadItemType() {
  return fetch(getUrl(`/cat/v1/dict/itemtype`)).then(data => {
    return data.json()
  }).then(json => {
    itemType = _.get(json, 'data.data', [])
  }).catch (err => {
    console.log(err)
  })
}

export function getItemType() {
  return itemType
}

export function getTemplate (typeId) {
  const item = itemType.find(e => {
    return e.id == typeId
  })
  return _.get(item, 'template', {}) || {}
}

export function getAttributes (cards) {
  const result = cards.map(card => {
    return getAttributesOneCard(card)
  })
  return result;
}

export function getAttributesOneCard (card) {
  if (card) {
    const item = itemType.find(i => i.id == card.type_id)
    let attrs = {
      // ...card.attribute,
      ...card.attribute_parse,
      code: card.article,
      ...(card.attribute_lang.comments ? { comments: card.attribute_lang.comments } : {}),
    };
    recursiveMapping(attrs, item.template)
    return attrs
  }
  return {}
}

function recursiveMapping (attributeInCard, attributeInItemType, key) {
  if (!key) {
    Object.keys(attributeInCard) && Object.keys(attributeInCard).forEach(k => {
      recursiveMapping(attributeInCard, attributeInItemType, k)
    })
  } else if (typeof attributeInCard[key] === 'object') {
    attributeInCard[key] && Object.keys(attributeInCard[key]) && Object.keys(attributeInCard[key]).forEach(k => {
      recursiveMapping(attributeInCard[key], attributeInItemType[key], k)
    })
  } else {
    if (attributeInItemType[key]) {
      if (attributeInItemType[key]['hide_ui']) {
        delete attributeInCard[key]
      } else if (attributeInItemType[key].title) {
        const newName = attributeInItemType[key].title
        attributeInCard[newName] = attributeInCard[key]
        delete attributeInCard[key]
      }
    } else {
      delete attributeInCard[key]
    }
  }
}


// WEBPACK FOOTER //
// ./src/itemtype.js